import React, { useEffect, useState } from 'react'
import { Slide, Snackbar } from '@material-ui/core'
import { Alert as MuiAlert } from '@material-ui/lab'
import { useSelector } from 'react-redux'

export const useSnackBar = () => {
  const [open, setOpen] = useState(false)
  const alertas = useSelector((state) => state.alertas)
  const handleClose = () => {
    setOpen(false)
  }

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
  })

  function SlideTransition(props) {
    return <Slide {...props} direction="left" />
  }

  useEffect(() => {
    if (alertas.status) setOpen(true)
  }, [alertas])

  const snackBar = (props) =>
    (props.isOpen || open) && (
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={props.isOpen || open}
        autoHideDuration={6000}
        onClose={handleClose}
        // eslint-disable-next-line react/jsx-no-bind
        TransitionComponent={SlideTransition}
      >
        <Alert onClose={handleClose} severity={props.variant || ''} sx={{ width: '100%' }}>
          {props.message || ''}
        </Alert>
      </Snackbar>
    )

  return snackBar
}
